import { defineAsyncIntegration } from '@teemill/modules/integration-framework';
import core from './core';

export const integrations = {
  core,

  drive: defineAsyncIntegration('drive', () => import('./drive')),
  domains: defineAsyncIntegration('domains', () => import('./domains')),
  orders: defineAsyncIntegration('orders', () => import('./orders')),
  products: defineAsyncIntegration('products', () => import('./products')),
  planner: defineAsyncIntegration('planner', () => import('./planner')),
  website: defineAsyncIntegration('website', () => import('./website')),
  marketing: defineAsyncIntegration('marketing', () => import('./marketing')),
  marketplaces: defineAsyncIntegration('marketplaces', () => import('./marketplaces')),
  flows: defineAsyncIntegration('flows', () => import('./flows')),
  discounts: defineAsyncIntegration('discounts', () => import('./discounts')),
  teemail: defineAsyncIntegration('teemail', () => import('./mail')),
  inserts: defineAsyncIntegration('inserts', () => import('./inserts')),
  conciergeCandidates: defineAsyncIntegration(
    'conciergeCandidates',
    () => import('./conciergeCandidates'),
  ),
  delivery: defineAsyncIntegration('delivery', () => import('./delivery')),
  productFeed: defineAsyncIntegration('productFeed', () => import('./productFeed')),
  platformFeed: defineAsyncIntegration('platformFeed', () => import('./platformFeed')),
  youtube: defineAsyncIntegration('youtube', () => import('./youtube')),
  cloudRip: defineAsyncIntegration('cloudRip', () => import('./cloudRip')),
  customers: defineAsyncIntegration('customers', () => import('./customers')),
  workflow: defineAsyncIntegration('workflow', () => import('./workflow')),
  okrs: defineAsyncIntegration('okrs', () => import('./okrs')),
  docs: defineAsyncIntegration('docs', () => import('./docs')),
  audiences: defineAsyncIntegration('audiences', () => import('./audiences')),

  shopify: defineAsyncIntegration('shopify', () => import('./shopify')),
  wooCommerce: defineAsyncIntegration('wooCommerce', () => import('./wooCommerce')),
  wooCommerceApp: defineAsyncIntegration('wooCommerceApp', () => import('./wooCommerceApp')),
  lightspeed: defineAsyncIntegration('lightspeed', () => import('./lightspeed')),
  lightspeedApp: defineAsyncIntegration('lightspeedApp', () => import('./lightspeedApp')),
  ecwid: defineAsyncIntegration('ecwid', () => import('./ecwid')),
  ecwidApp: defineAsyncIntegration('ecwidApp', () => import('./ecwidApp')),
  etsy: defineAsyncIntegration('etsy', () => import('./etsy')),
  wix: defineAsyncIntegration('wix', () => import('./wix')),
  ochre: defineAsyncIntegration('ochre', () => import('./ochre')),
  mirakl: defineAsyncIntegration('mirakl', () => import('./mirakl')),
  tiktokShop: defineAsyncIntegration('tiktokShop', () => import('./tiktokShop')),
  amazon: defineAsyncIntegration('amazon', () => import('./amazon')),
  amazonApp: defineAsyncIntegration('amazonApp', () => import('./amazonApp')),
  printify: defineAsyncIntegration('printify', () => import('./printify')),
  kickflip: defineAsyncIntegration('kickflip', () => import('./kickflip')),
  gelato: defineAsyncIntegration('gelato', () => import('./gelato')),
  rithum: defineAsyncIntegration('rithum', () => import('./rithum')),

  embroidery: defineAsyncIntegration('embroidery', () => import('./embroidery')),
  warehouse: defineAsyncIntegration('warehouse', () => import('./warehouse')),
  fulfillments: defineAsyncIntegration('fulfillments', () => import('./factory')),
  shipping: defineAsyncIntegration('shipping', () => import('./shipping')),
  platform: defineAsyncIntegration('platform', () => import('./platform')),
  reports: defineAsyncIntegration('reports', () => import('./reports')),
  crm: defineAsyncIntegration('crm', () => import('./crm')),
  gfn: defineAsyncIntegration('gfn', () => import('./gfn')),
  gtinsPlatform: defineAsyncIntegration('gtinsPlatform', () => import('./gtinsPlatform')),
  gtinsClient: defineAsyncIntegration('gtinsClient', () => import('./gtinsClient')),

  customDomain: defineAsyncIntegration('customDomain', () => import('./customDomain')),
  dns: defineAsyncIntegration('dns', () => import('./dns')),
  googleSearchConsole: defineAsyncIntegration(
    'googleSearchConsole',
    () => import('./googleSearchConsole'),
  ),
  googleAds: defineAsyncIntegration('googleAds', () => import('./googleAds')),
  googleAnalytics: defineAsyncIntegration('googleAnalytics', () => import('./googleAnalytics')),
  microsoft: defineAsyncIntegration('microsoft', () => import('./microsoft')),
  powerBi: defineAsyncIntegration('powerBi', () => import('./powerBi')),
  facebookPixel: defineAsyncIntegration('facebookPixel', () => import('./facebookPixel')),
  instagramShopping: defineAsyncIntegration(
    'instagramShopping',
    () => import('./instagramShopping'),
  ),
  pinterest: defineAsyncIntegration('pinterest', () => import('./pinterest')),
  currencies: defineAsyncIntegration('currencies', () => import('./currencies')),
  languages: defineAsyncIntegration('languages', () => import('./languages')),
  customCode: defineAsyncIntegration('customCode', () => import('./customCode')),
  sitewideBanner: defineAsyncIntegration('sitewideBanner', () => import('./sitewideBanner')),
  sitewidePopup: defineAsyncIntegration('sitewidePopup', () => import('./sitewidePopup')),
  reviews: defineAsyncIntegration('reviews', () => import('./reviews')),
  comingSoonPage: defineAsyncIntegration('comingSoonPage', () => import('./comingSoonPage')),
  adobeFonts: defineAsyncIntegration('adobeFonts', () => import('./adobeFonts')),
  customFonts: defineAsyncIntegration('customFonts', () => import('./customFonts')),
  redirects: defineAsyncIntegration('redirects', () => import('./redirects')),
  aiSeo: defineAsyncIntegration('aiSeo', () => import('./aiSeo')),
  aiBuilder: defineAsyncIntegration('aiBuilder', () => import('./aiBuilder')),
  aiArtworkTools: defineAsyncIntegration('aiArtworkTools', () => import('./aiArtworkTools')),

  thirdPartyLogistics: defineAsyncIntegration(
    'thirdPartyLogistics',
    () => import('./thirdPartyLogistics'),
  ),

  shipmate: defineAsyncIntegration('shipmate', () => import('./shipmate')),
  shipstation: defineAsyncIntegration('shipstation', () => import('./shipstation')),
  shiprocket: defineAsyncIntegration('shiprocket', () => import('./shiprocket')),
  shipCloud: defineAsyncIntegration('shipCloud', () => import('./shipCloud')),
  sendCloud: defineAsyncIntegration('sendCloud', () => import('./sendCloud')),
  easyPost: defineAsyncIntegration('easyPost', () => import('./easyPost')),
  avalara: defineAsyncIntegration('avalara', () => import('./avalara')),

  resupply: defineAsyncIntegration('resupply', () => import('./resupply')),
  ralawise: defineAsyncIntegration('ralawise', () => import('./ralawise')),
  sands: defineAsyncIntegration('sands', () => import('./sands')),
  pencarrie: defineAsyncIntegration('pencarrie', () => import('./pencarrie')),
  sanmar: defineAsyncIntegration('sanmar', () => import('./sanmar')),
  ststus: defineAsyncIntegration('ststus', () => import('./stanleyStellaUS')),
  ststeu: defineAsyncIntegration('ststeu', () => import('./stanleyStellaEU')),

  customStudio: defineAsyncIntegration('customStudio', () => import('./customStudio')),
  aiVideo: defineAsyncIntegration('aiVideo', () => import('./aiVideo')),
  aiMockups: defineAsyncIntegration('aiMockups', () => import('./aiMockups')),
  aiStudio: defineAsyncIntegration('aiStudio', () => import('./aiStudio')),
  posta: defineAsyncIntegration('posta', () => import('./posta')),

  customPackaging: defineAsyncIntegration('customPackaging', () => import('./customPackaging')),

  faqs: defineAsyncIntegration('faqs', () => import('./faqs')),

  moderation: defineAsyncIntegration('moderation', () => import('./moderation')),

  // Private
  lemonstand: defineAsyncIntegration('lemonstand', () => import('./lemonstand')),
  suppliers: defineAsyncIntegration('suppliers', () => import('./suppliers')),
} as const;

export type Integrations = typeof integrations;
